import { render, staticRenderFns } from "./RecordedMainMenu.vue?vue&type=template&id=8bb8d962&"
import script from "./RecordedMainMenu.vue?vue&type=script&lang=ts&"
export * from "./RecordedMainMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports